// extracted by mini-css-extract-plugin
export default {"saveSaleHeader":"SaveSaleModal_saveSaleHeader__2VbCW"};